document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var overlay = document.querySelector('[data-overlay]');
  var navDrawer = document.querySelector('[data-nav-drawer]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var wishlistDrawer = document.querySelector('[data-wishlist-drawer]');

  /* ---------- Drawer helpers ---------- */
  function anyDrawerOpen() { return document.querySelector('.nav-drawer.open, .cart-drawer.open, .wishlist-drawer.open'); }
  function lock() { body.classList.add('no-scroll'); }
  function unlock() { if (!anyDrawerOpen()) body.classList.remove('no-scroll'); }
  function showOverlay() { if (overlay) overlay.classList.add('active'); }
  function hideOverlay() { if (overlay) overlay.classList.remove('active'); }

  /* ---------- Focus trap (a11y) ---------- */
  var lastFocused = null;
  function focusables(el) { return el ? Array.prototype.slice.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (n) { return n.offsetParent !== null; }) : []; }
  function trapFocus(el) { if (!lastFocused) lastFocused = document.activeElement; var f = focusables(el); if (f.length) setTimeout(function () { f[0].focus(); }, 60); }
  function releaseFocus() { if (!anyDrawerOpen() && lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} lastFocused = null; } }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = anyDrawerOpen(); if (!open) return;
    var f = focusables(open); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function openNav() { if (!navDrawer) return; closeCart(); closeWishlist(); navDrawer.classList.add('open'); navDrawer.setAttribute('aria-hidden', 'false'); showOverlay(); lock(); trapFocus(navDrawer); }
  function closeNav() { if (!navDrawer) return; navDrawer.classList.remove('open'); navDrawer.setAttribute('aria-hidden', 'true'); if (!anyDrawerOpen()) hideOverlay(); unlock(); releaseFocus(); }
  function openCart() { if (!cartDrawer) return; closeNav(); closeWishlist(); cartDrawer.classList.add('open'); cartDrawer.setAttribute('aria-hidden', 'false'); showOverlay(); lock(); trapFocus(cartDrawer); }
  function closeCart() { if (!cartDrawer) return; cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); if (!anyDrawerOpen()) hideOverlay(); unlock(); releaseFocus(); }
  function openWishlist() { if (!wishlistDrawer) return; closeNav(); closeCart(); wishlistDrawer.classList.add('open'); wishlistDrawer.setAttribute('aria-hidden', 'false'); showOverlay(); lock(); renderWishlist(); trapFocus(wishlistDrawer); }
  function closeWishlist() { if (!wishlistDrawer) return; wishlistDrawer.classList.remove('open'); wishlistDrawer.setAttribute('aria-hidden', 'true'); if (!anyDrawerOpen()) hideOverlay(); unlock(); releaseFocus(); }

  document.querySelectorAll('[data-open-nav]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openNav(); }); });
  document.querySelectorAll('[data-close-nav]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeNav(); }); });
  document.querySelectorAll('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); refreshCart(false); }); });
  document.querySelectorAll('[data-close-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeCart(); }); });
  document.querySelectorAll('[data-open-wishlist]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openWishlist(); }); });
  document.querySelectorAll('[data-close-wishlist]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeWishlist(); }); });
  if (overlay) overlay.addEventListener('click', function () { closeNav(); closeCart(); closeWishlist(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeNav(); closeCart(); closeWishlist(); } });

  /* ---------- Header: Schatten beim Scrollen ---------- */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var onScroll = function () { siteHeader.classList.toggle('is-scrolled', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Produktkarten-Bild-Slider (Blättern ohne Klick) ---------- */
  function cardSlide(card, dir) {
    var slides = card.querySelectorAll('[data-card-slide]');
    if (slides.length < 2) return;
    var i = 0;
    slides.forEach(function (s, idx) { if (s.classList.contains('is-active')) i = idx; });
    var n = i + dir;
    if (n < 0 || n > slides.length - 1) return; // begrenzt, kein Umlauf
    var target = slides[n];
    if (target.dataset.src && !target.getAttribute('src')) target.src = target.dataset.src; // erst jetzt laden
    slides[i].classList.remove('is-active');
    target.classList.add('is-active');
    var prev = card.querySelector('[data-card-prev]'), next = card.querySelector('[data-card-next]');
    if (prev) prev.classList.toggle('is-hidden', n <= 0);
    if (next) next.classList.toggle('is-hidden', n >= slides.length - 1);
    var nb = slides[n + dir]; // Nachbar in Blätterrichtung vorladen
    if (nb && nb.dataset.src && !nb.getAttribute('src')) nb.src = nb.dataset.src;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-prev],[data-card-next]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var card = btn.closest('.pcard');
    if (card) cardSlide(card, btn.hasAttribute('data-card-next') ? 1 : -1);
  });
  var cTouchX = null, cTouchY = null, cTouchEl = null;
  document.addEventListener('touchstart', function (e) {
    var sl = e.target.closest('[data-card-slides]');
    if (!sl) return;
    cTouchX = e.touches[0].clientX; cTouchY = e.touches[0].clientY; cTouchEl = sl.closest('.pcard');
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (cTouchX == null || !cTouchEl) return;
    var dx = e.changedTouches[0].clientX - cTouchX, dy = e.changedTouches[0].clientY - cTouchY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cardSlide(cTouchEl, dx < 0 ? 1 : -1);
    cTouchX = null; cTouchY = null; cTouchEl = null;
  }, { passive: true });

  /* ---------- Mobile drawer sub-menus ---------- */
  document.querySelectorAll('.nd-toggle').forEach(function (t) {
    t.addEventListener('click', function () {
      var li = t.closest('.nd-has-sub');
      var open = li.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Mega menu: tap to open on touch ---------- */
  if (window.matchMedia('(hover: none)').matches) {
    document.querySelectorAll('.nav-item.has-mega > a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var li = a.parentNode;
        if (!li.classList.contains('open')) { e.preventDefault(); document.querySelectorAll('.nav-item.open').forEach(function (o) { if (o !== li) o.classList.remove('open'); }); li.classList.add('open'); }
      });
    });
  }

  /* ---------- Cart (AJAX) ---------- */
  var cartBody = document.querySelector('[data-cart-body]');
  var cartEmpty = document.querySelector('[data-cart-empty]');
  var cartFoot = document.querySelector('[data-cart-foot]');
  var cartOriginal = document.querySelector('[data-cart-original]');
  var cartDiscountRow = document.querySelector('[data-cart-discount-row]');
  var cartDiscount = document.querySelector('[data-cart-discount]');
  var cartShipping = document.querySelector('[data-cart-shipping]');
  var cartTotal = document.querySelector('[data-cart-total]');
  var cartSaveBanner = document.querySelector('[data-cart-save-banner]');
  var cartSaveAmount = document.querySelector('[data-cart-save-amount]');
  var shippingBar = document.querySelector('[data-shipping-bar]');
  var shippingMsg = document.querySelector('[data-shipping-msg]');
  var shippingProgress = document.querySelector('[data-shipping-progress]');
  var shippingNote = document.querySelector('[data-shipping-note]');
  var FREE_SHIPPING_CENTS = 4900;

  function updateCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? '' : ''; }); }

  function updateShippingBar(totalCents) {
    if (!shippingBar) return;
    var pct = Math.min(100, (totalCents / FREE_SHIPPING_CENTS) * 100);
    var isFree = totalCents >= FREE_SHIPPING_CENTS;

    if (shippingProgress) shippingProgress.style.width = pct + '%';

    if (shippingMsg) {
      if (totalCents === 0) {
        shippingMsg.innerHTML = '';
        shippingBar.hidden = true;
      } else if (isFree) {
        shippingMsg.innerHTML = '<span class="cd-shipping-free">✦ Versandkostenfrei!</span>';
        shippingBar.hidden = false;
        shippingBar.classList.add('is-free');
      } else {
        var diff = FREE_SHIPPING_CENTS - totalCents;
        shippingMsg.innerHTML = 'Noch <strong>' + window.__money(diff) + '</strong> bis zum kostenlosen Versand';
        shippingBar.hidden = false;
        shippingBar.classList.remove('is-free');
      }
    }

    if (shippingNote) {
      if (isFree && totalCents > 0) {
        shippingNote.innerHTML = '<span class="cd-free-badge">✦ Kostenloser Versand</span>';
      } else {
        shippingNote.innerHTML = '<p class="cd-note">Versand &amp; Rabatte werden an der Kasse berechnet.</p>';
      }
    }
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    updateShippingBar(cart.items_subtotal_price);
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '';
      if (cartEmpty) cartEmpty.hidden = false;
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    if (cartEmpty) cartEmpty.hidden = true;
    if (cartFoot) cartFoot.hidden = false;
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cd-item__variant">' + item.variant_title + '</span>' : '';
      html += '<div class="cd-item" data-key="' + item.key + '">'
        + (img ? '<a href="' + item.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' : '<span class="cd-item__ph"></span>')
        + '<div class="cd-item__info">'
        + '<a href="' + item.url + '"><h4>' + item.product_title + '</h4></a>' + variant
        + '<div class="cd-qty"><button type="button" data-dec aria-label="Weniger">−</button><span>' + item.quantity + '</span><button type="button" data-inc aria-label="Mehr">+</button></div>'
        + '</div>'
        + '<div class="cd-item__price">' + window.__money(item.final_line_price) + '</div>'
        + '</div>';
    });
    cartBody.innerHTML = html;

    /* price breakdown */
    var discount = cart.total_discount || 0;           // automatic + code discounts
    var total = cart.total_price;                       // after discounts (excl. shipping/tax)
    var original = cart.original_total_price != null ? cart.original_total_price : (total + discount); // before discounts
    var freeShip = cart.items_subtotal_price >= FREE_SHIPPING_CENTS;

    if (cartOriginal) cartOriginal.textContent = window.__money(original);
    if (cartDiscountRow) cartDiscountRow.hidden = discount <= 0;
    if (cartDiscount) cartDiscount.textContent = '− ' + window.__money(discount);
    if (cartShipping) cartShipping.innerHTML = freeShip
      ? '<span class="cd-ship-free">Kostenlos</span>'
      : 'Wird an der Kasse berechnet';
    if (cartTotal) cartTotal.textContent = window.__money(total);

    if (cartSaveBanner) {
      cartSaveBanner.hidden = discount <= 0;
      if (cartSaveAmount) cartSaveAmount.textContent = window.__money(discount);
    }
  }

  function refreshCart(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); })
      .catch(function () {});
  }

  function changeCart(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item'); if (!row) return;
      var key = row.dataset.key;
      var qtyEl = row.querySelector('.cd-qty span');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      if (e.target.closest('[data-inc]')) changeCart(key, qty + 1);
      else if (e.target.closest('[data-dec]')) changeCart(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-remove]')) changeCart(key, 0);
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WL_KEY = 'mg_wishlist';
  var wishlistBody = document.querySelector('[data-wishlist-body]');
  var wishlistEmpty = document.querySelector('[data-wishlist-empty]');

  function wlGet() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; }
    catch (e) { return []; }
  }
  function wlSave(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function wlHas(id) { return wlGet().some(function (p) { return String(p.id) === String(id); }); }

  function wlToggle(item) {
    var list = wlGet();
    var idx = list.findIndex(function (p) { return String(p.id) === String(item.id); });
    if (idx !== -1) { list.splice(idx, 1); }
    else { list.unshift(item); }
    wlSave(list);
    wlUpdateCount();
    wlSyncHearts();
    renderWishlist();
    return idx === -1; // true if added
  }

  function wlRemove(id) {
    var list = wlGet().filter(function (p) { return String(p.id) !== String(id); });
    wlSave(list);
    wlUpdateCount();
    wlSyncHearts();
    renderWishlist();
  }

  function wlUpdateCount() {
    var n = wlGet().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function wlSyncHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = wlHas(btn.dataset.wlId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Von Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
    });
  }

  function renderWishlist() {
    if (!wishlistBody) return;
    var list = wlGet();
    if (!list.length) {
      wishlistBody.innerHTML = '';
      if (wishlistEmpty) wishlistEmpty.hidden = false;
      return;
    }
    if (wishlistEmpty) wishlistEmpty.hidden = true;
    var html = '';
    list.forEach(function (item) {
      var canAdd = item.variant && String(item.available) === 'true' && parseInt(item.variants || '1', 10) <= 1;
      var multiVariant = parseInt(item.variants || '1', 10) > 1;
      var soldOut = String(item.available) !== 'true';
      var actionBtn;
      if (soldOut) {
        actionBtn = '<span class="wl-item__add is-out">Ausverkauft</span>';
      } else if (multiVariant) {
        actionBtn = '<a href="' + item.url + '" class="wl-item__add">Optionen wählen</a>';
      } else {
        actionBtn = '<button type="button" class="wl-item__add" data-wl-add="' + item.variant + '" data-wl-add-id="' + item.id + '">In den Warenkorb</button>';
      }
      html += '<div class="cd-item wl-item" data-wl-row="' + item.id + '">'
        + (item.image ? '<a href="' + item.url + '"><img src="' + item.image + '" alt="" loading="lazy"></a>' : '<span class="cd-item__ph"></span>')
        + '<div class="cd-item__info">'
        + '<a href="' + item.url + '"><h4>' + item.title + '</h4></a>'
        + (item.price ? '<span class="wl-item__price">' + item.price + '</span>' : '')
        + actionBtn
        + '<button type="button" class="cd-remove wl-item__remove" data-wl-remove="' + item.id + '">Entfernen</button>'
        + '</div>'
        + '</div>';
    });
    wishlistBody.innerHTML = html;
  }

  function wlAddToCart(variantId, productId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (productId) wlRemove(productId);
      refreshCart(true);
    })
    .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; } });
  }

  if (wishlistBody) {
    wishlistBody.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wl-remove]');
      if (rm) { e.preventDefault(); wlRemove(rm.dataset.wlRemove); return; }
      var add = e.target.closest('[data-wl-add]');
      if (add) { e.preventDefault(); wlAddToCart(add.dataset.wlAdd, add.dataset.wlAddId, add); }
    });
  }

  /* heart toggles on product cards (event delegation) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = wlToggle({
      id: btn.dataset.wlId,
      handle: btn.dataset.wlHandle,
      title: btn.dataset.wlTitle,
      url: btn.dataset.wlUrl,
      image: btn.dataset.wlImage,
      price: btn.dataset.wlPrice,
      variant: btn.dataset.wlVariant,
      variants: btn.dataset.wlVariants,
      available: btn.dataset.wlAvailable
    });
    btn.classList.toggle('just-added', added);
    if (added) { setTimeout(function () { btn.classList.remove('just-added'); }, 600); }
  });

  wlUpdateCount();
  wlSyncHearts();
  renderWishlist();
  document.addEventListener('shopify:section:load', function () { wlSyncHearts(); });

  /* Intercept add-to-cart forms -> AJAX + open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action]')) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');

    /* Folie der Woche: hard cap at 5 per variant across the cart */
    if (form.classList.contains('fow-form')) {
      var fd = new FormData(form);
      var vid = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10);
      if (btn) { btn.disabled = true; btn.dataset.prev = btn.textContent; btn.textContent = 'Wird hinzugefügt …'; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var existing = 0;
          cart.items.forEach(function (it) { if (String(it.id) === String(vid)) existing += it.quantity; });
          var allowed = Math.max(0, 1 - existing);
          if (allowed <= 0) { alert('Die Folie der Woche kann nur einmal pro Bestellung hinzugefügt werden.'); return null; }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: Math.min(qty, allowed) }) }).then(function () { refreshCart(true); });
        })
        .catch(function () {})
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prev || btn.dataset.label || 'In den Warenkorb'; } });
      return;
    }

    if (btn) { btn.disabled = true; btn.dataset.prev = btn.textContent; btn.textContent = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prev || btn.dataset.label || 'In den Warenkorb'; } });
  });

  // Populate count on load
  refreshCart(false);

  /* ---------- Countdown timer ---------- */
  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      function tick() {
        var now = Date.now(), diff = Math.max(0, end - now);
        var d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000),
            m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
        el.innerHTML = '<span>' + d + '<small>Tage</small></span><span>' + h + '<small>Std</small></span><span>' + m + '<small>Min</small></span><span>' + s + '<small>Sek</small></span>';
        if (diff > 0) requestAnimationFrame(tick);
      }
      tick();
    });
  }
  initCountdowns();

  /* ---------- Folie der Woche: auto-switch by time ---------- */
  function initFoil(scope) {
    (scope || document).querySelectorAll('[data-foil-group]').forEach(function (g) {
      var hasNext = g.dataset.hasNext === 'true';
      var switchAt = g.dataset.switchAt;
      var active = 'current';
      if (hasNext && switchAt) {
        var t = new Date(switchAt).getTime();
        if (!isNaN(t) && Date.now() >= t) active = 'next';
      }
      g.querySelectorAll('[data-foil-slot]').forEach(function (el) {
        el.hidden = el.dataset.foilSlot !== active;
      });
    });
  }
  initFoil();
  window.__initFoil = initFoil;


  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('.product-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () { var main = document.querySelector('.main-media img'); if (main) main.src = thumb.dataset.full || thumb.src; });
  });

  /* ---------- Product variants ---------- */
  var pform = document.querySelector('[data-product-form]');
  if (pform && window.__glazeVariants) {
    var selects = pform.querySelectorAll('select[data-option]');
    function updateVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = window.__glazeVariants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      var idField = pform.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var btn = pform.querySelector('[data-add-btn]');
      if (match) {
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? btn.dataset.label : 'Ausverkauft'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    updateVariant();
  }
});

/* ===== Shopify Theme Editor: re-init sections after edit ===== */
document.addEventListener('shopify:section:load', function (e) {
  var section = e.target;

  /* Re-init reveal animations inside the re-rendered section */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    section.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    section.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* Re-init mobile drawer toggles */
  section.querySelectorAll('.nd-toggle').forEach(function (t) {
    t.addEventListener('click', function () {
      var li = t.closest('.nd-has-sub');
      var open = li.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Re-init countdowns */
  if (typeof initCountdowns === 'function') initCountdowns(section);

  /* Re-init Folie der Woche auto-switch */
  if (window.__initFoil) window.__initFoil(section);

  /* Re-init collection filters */
  var aside = section.querySelector('.collection-filters');
  var ov = section.querySelector('[data-filters-overlay]');
  if (aside && ov) {
    function openF() { aside.classList.add('open'); ov.classList.add('active'); document.body.classList.add('no-scroll'); }
    function closeF() { aside.classList.remove('open'); ov.classList.remove('active'); document.body.classList.remove('no-scroll'); }
    section.querySelectorAll('[data-open-filters]').forEach(function (b) { b.addEventListener('click', openF); });
    section.querySelectorAll('[data-close-filters]').forEach(function (b) { b.addEventListener('click', closeF); });
    ov.addEventListener('click', closeF);
  }
});

/* Highlight selected block in editor */
document.addEventListener('shopify:block:select', function (e) {
  var block = e.target;
  if (block.closest('.faq')) {
    block.setAttribute('open', '');
  }
});

/* ============================================================================
   PERSÖNLICHKEIT — Bewegung (2026-09-13)
   Wörter, die sich aufrichten · gestaffelte Reihen · Bildtiefe · Lesefortschritt
   Ein einziger rAF-Handler für alle scrollabhängigen Teile.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Überschriften in Wörter zerlegen ---------------------------------- */
  var SPLIT_SEL = '.section-head h2, .hero h1, .founder h2, .guarantee h2, ' +
                  '.newsletter h2, .fow-section h2, .pdp__title';
  var SKIP_INSIDE = '.pcard, .cat, .step-card, li, td, th, details, summary, .reco-card';

  function splitWords(el) {
    if (el.dataset.mgSplit || el.closest(SKIP_INSIDE)) return;
    var text = el.textContent || '';
    if (!text.trim() || text.length > 120) return;

    var w = 0, MAX = 40;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.nodeValue.trim()) return;
          var frag = document.createDocumentFragment();
          n.nodeValue.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part) || w >= MAX) {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            var span = document.createElement('span');
            span.className = 'mgw';
            span.style.setProperty('--w', w++);
            var inner = document.createElement('i');
            inner.textContent = part;
            span.appendChild(inner);
            frag.appendChild(span);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR' && !n.classList.contains('mgw')) {
          walk(n);
        }
      });
    })(el);

    el.dataset.mgSplit = '1';
    el.classList.add('mgw-ready');

    /* Die Elternhülle soll sich zurücknehmen – die Bewegung tragen die Wörter. */
    var host = el.closest('.reveal');
    if (host && !host.getAttribute('data-rv')) host.setAttribute('data-rv', 'ruhig');
  }

  /* --- Reihen nacheinander eintreffen lassen ------------------------------ */
  function stagger(root) {
    var byParent = [];
    root.querySelectorAll('.reveal').forEach(function (el) {
      var p = el.parentNode;
      if (!p) return;
      var entry = null;
      for (var i = 0; i < byParent.length; i++) {
        if (byParent[i][0] === p) { entry = byParent[i]; break; }
      }
      if (!entry) { entry = [p, []]; byParent.push(entry); }
      entry[1].push(el);
    });
    byParent.forEach(function (entry) {
      var list = entry[1];
      if (list.length < 2) return;
      list.forEach(function (el, i) {
        if (i && !el.style.getPropertyValue('--i')) {
          el.style.setProperty('--i', String(Math.min(i, 6)));
        }
      });
    });
  }

  /* --- Jede Sektion bekommt einen eigenen Charakter ----------------------- */
  var CHARACTER = [
    ['.founder-img', 'links'],
    ['.founder-grid > .reveal:last-child', 'rechts'],
    ['.cat-grid > .reveal, .step-grid > .reveal', 'tief'],
    ['.best-grid > .reveal, .product-grid > .reveal', 'tief'],
    ['.comparison-table, .comp-table', 'vorhang'],
    ['.rte.reveal, .lead.reveal', 'weich']
  ];
  function character(root) {
    CHARACTER.forEach(function (pair) {
      root.querySelectorAll(pair[0]).forEach(function (el) {
        if (el.classList.contains('reveal') && !el.getAttribute('data-rv')) {
          el.setAttribute('data-rv', pair[1]);
        }
      });
    });
  }

  /* --- Ein rAF für Bildtiefe und Lesefortschritt -------------------------- */
  var paraEls = [];
  var header = document.querySelector('.site-header');
  var ticking = false;

  function frame() {
    ticking = false;
    var vh = window.innerHeight || 1;

    for (var i = 0; i < paraEls.length; i++) {
      var el = paraEls[i];
      if (!el.__mgVisible) continue;
      var r = el.getBoundingClientRect();
      var mid = (r.top + r.height / 2 - vh / 2) / vh;   /* -1 … 1 */
      if (mid < -1.4 || mid > 1.4) continue;
      var strength = parseFloat(el.getAttribute('data-para')) || 26;
      el.style.setProperty('--py', (-mid * strength).toFixed(1) + 'px');
    }

    if (header) {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var pct = max > 0 ? (doc.scrollTop / max) * 100 : 0;
      header.style.setProperty('--mg-progress', pct.toFixed(2) + '%');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  /* --- Nachbar-Kennzeichnung ------------------------------------------------
     Drei Wellen im Theme sind mit der Farbe des NACHBARN gefüllt
     (.hero, .social-proof, .founder). Bringt der nächste SICHTBARE Abschnitt
     seine eigene Welle mit (.bg-alt::before), müssen sie weichen, sonst liegen
     zwei Wellen übereinander. In CSS ginge das nicht zuverlässig: Shopify
     rendert für JEDE Sektion eine Hülle, auch für solche, die nichts ausgeben
     (Presse, Community, Bewertungen ohne Einträge) – ein `+`-Selektor würde
     also auf eine leere Hülle zeigen. Hier werden sie übersprungen. */
  function markNeighbours() {
    var sichtbar = [];
    document.querySelectorAll('main > .shopify-section').forEach(function (w) {
      var el = w.firstElementChild;
      if (el && el.getBoundingClientRect().height > 0) sichtbar.push(el);
    });
    for (var i = 0; i < sichtbar.length; i++) {
      var next = sichtbar[i + 1];
      if (next && next.classList.contains('bg-alt')) {
        sichtbar[i].setAttribute('data-next-alt', '');
      } else {
        sichtbar[i].removeAttribute('data-next-alt');
      }
    }
  }

  /* --- Aufbau ------------------------------------------------------------- */
  function init(root) {
    root = root || document;
    if (!reduce) {
      root.querySelectorAll(SPLIT_SEL).forEach(splitWords);
      character(root);
      stagger(root);
    }

    /* Wörter starten, sobald die Überschrift sichtbar wird. */
    if (!reduce && 'IntersectionObserver' in window) {
      var wo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mgw-in'); wo.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('.mgw-ready:not(.mgw-in)').forEach(function (el) { wo.observe(el); });
    } else {
      root.querySelectorAll('.mgw-ready').forEach(function (el) { el.classList.add('mgw-in'); });
    }

    /* Bildtiefe – nur rechnen, solange das Bild wirklich im Blick ist. */
    if (!reduce) {
      root.querySelectorAll('.founder-img img').forEach(function (img) {
        if (!img.hasAttribute('data-para')) img.setAttribute('data-para', '30');
      });
      var fresh = Array.prototype.slice.call(root.querySelectorAll('[data-para]'))
        .filter(function (el) { return paraEls.indexOf(el) === -1; });
      if (fresh.length && 'IntersectionObserver' in window) {
        var po = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.target.__mgVisible = e.isIntersecting; });
          onScroll();
        }, { rootMargin: '25% 0px' });
        fresh.forEach(function (el) { po.observe(el); paraEls.push(el); });
      }
    }

    markNeighbours();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Im Theme-Editor neu aufbauen, wenn eine Sektion neu gerendert wird. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.MGPersona = { init: init };
})();
